<template>
  <input
    v-if="typeField === 'dadata'"
    ref="suggestions"
    v-model="suggestCity"
    class="field-input__inner form__input"
    :placeholder="placeholder"
    :required="required"
    type="text"
    @keyup.enter="keyupEnter"
  >
  <multiselect
    v-else-if="typeField === 'select' || this.$root.typeField === 'select'"
    ref="multiselect"
    v-model="cityCodeData"
    :options="options"
    :searchable="true"
    :internal-search="false"
    :custom-label="nameCity"
    :close-on-select="true"
    :show-labels="false"
    :placeholder="placeholder"
    class="field-input__inner form__input  multiselect_city"
    :class="{'multiselect_hide-content': hideContent}"
    @search-change="onSearch"
    @close="closeDropDown"
    @open="openDropDown"
  >
    <template
      slot="option"
      slot-scope="props"
    >
      <div class="input-city__desc">
        <span class="input-city__city">
          {{ getPrefix(props.option.Prefix) }} {{ props.option.Name }}
        </span>
        <span class="input-city__region">
          {{ props.option.Region }}
        </span>
      </div>
    </template>
    <span slot="noResult">Ничего не найдено</span>
  </multiselect>
</template>
<script>
// eslint-disable-next-line no-redeclare
/* global $ */

import Multiselect from 'vue-multiselect';
import scrollToEl from '../../mixins/scrollToEl';
import autoKeyboardLang from '../../helpers/auto-keyboard-lang';
import { getters as cityRepositoryGetters, actions as cityRepositoryActions } from '../../store/city.repository';
import { getters as cityGetters } from '../../store/city.store';
import { dadataApi } from '../../helpers/url';
import { COUNTRY_CODES } from '../../helpers/constans';

// const _ = require('lodash');

export default {
  name: 'InputCitySuggest',
  components: {
    Multiselect,
  },
  mixins: [scrollToEl],
  props: {
    defaultCity: Object, // Выбранный по умолчанию город
    type: {
      type: String,
      default: 'ADDRESS',
    },
    hint: {
      type: Boolean,
      default: false,
    },
    scrollOnFocus: {
      type: Boolean,
      default: false,
    },
    noSuggestionsHint: {
      type: String,
      default: 'Ничего не найдено',
    },
    geoLocation: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Город*',
    },
    typeField: {
      type: String,
      default: '',
    },
    search: {
      type: String,
      default: '',
    },
    filtered: {
      type: String,
      default: 'noFiltered',
    },
    selectedDefaultCity: {
      type: Boolean,
      default: false,
    },
    countryCode: {
      type: [Number, String],
      default: '',
    },
    acceptableCountiesFrom: {
      type: [Array, String],
      default: '',
    },
    acceptableCountiesTo: {
      type: [Array, String],
      default: '',
    },
  },
  data() {
    return {
      cityCodeData: null,
      suggestCity: cityGetters.name(),
      query: '',
      hideContent: true,
      closeOptions: true,
    };
  },
  computed: {
    ...cityGetters,
    selectedCity() {
      if (this.selectedDefaultCity && this.cityCodeData && this.cityCodeData.Name === null && cityGetters.code() !== null) {
        return { Code: cityGetters.code(), Name: cityGetters.name() };
      }
      if (this.selectedDefaultCity) {
        return this.cityCodeData || { Code: cityGetters.code(), Name: cityGetters.name() };
      }
      return this.cityCodeData;
    },
    ...cityRepositoryGetters, // cities()
    listOfCities() {
      const cities = cityRepositoryActions.sort(cityRepositoryGetters.cities(), 'Name');
      let topCities = [];
      if (this.countryCode) {
        switch (this.countryCode.toString()) {
          case COUNTRY_CODES.BELARUS:
            topCities = ['Брест', 'Витебск', 'Могилев', 'Гомель', 'Минск'];
            break;
          case COUNTRY_CODES.KAZAKHSTAN:
            topCities = ['Караганда', 'Актобе', 'Шымкент', 'Астана', 'Алматы', 'Алма-Ата'];
            break;
          case COUNTRY_CODES.KYRGYZSTAN:
            topCities = ['Каракол', 'Джалал-Абад', 'Ош', 'Бишкек'];
            break;
          case COUNTRY_CODES.UZBEKISTAN:
            topCities = ['Бухара', 'Андижан', 'Самарканд', 'Наманган', 'Ташкент'];
            break;
          case COUNTRY_CODES.ARMENIA:
            topCities = ['Раздан', 'Ванадзор', 'Гюмри', 'Ереван'];
            break;
          case COUNTRY_CODES.RUSSIA:
            topCities = ['Краснодар', 'Екатеринбург', 'Санкт-Петербург', 'Москва'];
            break;
          default:
            break;
        }
      }

      topCities.forEach((city) => {
        const cityIndex = cities.findIndex((cityItem) => cityItem.Name === city);
        if (cityIndex !== -1) {
          cities.unshift(cities[cityIndex]);
          cities.splice(cityIndex + 1, 1);
        }
      });
      let citiesFiltered = this.filtered !== 'noFiltered' ? cityRepositoryActions.filter(cities, this.filtered) : cities;

      if (this.filtered === 'Reception_lap' && this.acceptableCountiesFrom.length) {
        citiesFiltered = citiesFiltered.filter((city) => this.acceptableCountiesFrom.includes(city.Country_code));
      }
      if (this.filtered === 'Delivery_lap' && this.acceptableCountiesTo.length) {
        citiesFiltered = citiesFiltered.filter((city) => this.acceptableCountiesTo.includes(city.Country_code));
      }
      if (!this.countryCode) {
        return citiesFiltered;
      }
      return citiesFiltered.filter((city) => city.Country_code === this.countryCode);
    },
    options() {
      if (this.hideContent) return [];
      const options = this.listOfCities.filter((city) => city.Name.toLowerCase().replace('ё', 'е').includes(this.query));

      if (!String.prototype.startsWith) {
        // eslint-disable-next-line no-extend-native
        Object.defineProperty(String.prototype, 'startsWith', {
          enumerable: false,
          configurable: false,
          writable: false,
          value(searchString, position) {
            // eslint-disable-next-line no-param-reassign
            position = position || 0;
            return this.indexOf(searchString, position) === position;
          },
        });
      }

      if (this.query) {
        const optionsStarts = [];
        const optionsFinish = [];

        options.forEach((option) => {
          if (option.Name.toLowerCase().startsWith(this.query)) {
            optionsStarts.push(option);
          } else {
            optionsFinish.push(option);
          }
        });
        return [...optionsStarts, ...optionsFinish];
      }
      return options;
    },
  },
  watch: {
    selectedCity(val) {
      this.cityCodeData = val;
    },
    countryCode(countryCode) {
      if (!this.cityCodeData || this.cityCodeData.Country_code !== countryCode) {
        this.cityCodeData = null;
      }
    },
  },
  mounted() {
    if (this.typeField === 'dadata') {
      $(this.$refs.suggestions).suggestions({
        serviceUrl: dadataApi,
        type: this.type,
        hint: this.hint,
        bounds: 'city-settlement',
        noSuggestionsHint: this.noSuggestionsHint,
        geoLocation: this.geoLocation,
        scrollOnFocus: this.scrollOnFocus,
        constraints: {
          label: '',
          // locations: { city_type_full: 'город' },
        },
        onSelect: this.onSelect,
        onSelectNothing: this.onSelectNothing,
      });
      $(this.$refs.suggestions).suggestions().fixData();
    }
  },
  created() {
    if (this.selectedDefaultCity) {
      this.cityCodeData = { Code: cityGetters.code(), Name: cityGetters.name() };
      this.$emit('change-city-default', this.cityCodeData);
    }
  },
  updated() {
    if (this.typeField === 'select') {
      let cityData;
      if (this.cityCodeData && this.cityCodeData.Code && typeof this.cityCodeData.Code !== 'undefined') {
        cityData = {
          Code: this.cityCodeData.Code,
          Name: this.cityCodeData.Name,
          Region: this.cityCodeData.Region,
        };
      } else if (this.cityCodeData) {
        const city = cityRepositoryGetters.find(this.cityCodeData);
        if (city) {
          cityData = {
            Code: city.Code,
            Name: city.Name,
            Region: city.Region,
          };
        }
      } else {
        cityData = {
          Code: '',
          Name: '',
          Region: '',
        };
      }
      if (cityData) {
        this.$emit('change-city', cityData);
        const citySelected = this.listOfCities.find((item) => item.Code === cityData.Code);
        if (citySelected) {
          this.$emit('change-country-code', citySelected.Country_code);
        }
      }
    }
  },
  methods: {
    nameCity({ Name, Region, Prefix }) {
      const city = Region ? `${Name} (${Region})` : `${Name}`;
      return Prefix ? `${Prefix}. ${city}` : city;
    },
    onSelect(suggestion) {
      if (suggestion.data) {
        this.$emit('city-select', suggestion.data);
      }
    },
    onSelectNothing() {
      this.$emit('select-nothing');
    },
    keyupEnter() {
      this.$emit('keyup-enter');
    },
    onSearch(query) {
      const queryTrans = (/^[а-яё ]*$/i.test(query)) ? query : autoKeyboardLang(query);
      this.$refs.multiselect.search = queryTrans;
      switch (queryTrans.toLowerCase()) {
        case 'питер':
        case 'пите':
          this.query = 'санкт-петербург';
          break;
        case 'алмат':
        case 'алматы':
          this.query = 'алма-ата';
          break;
        default:
          this.query = queryTrans.toLowerCase().replace('ё', 'е');
      }
    },
    closeDropDown() {
      const TIME_TRANSITION = 300;
      this.closeOptions = true;
      setTimeout(() => {
        if (this.closeOptions === true) {
          this.hideContent = true;
        }
      }, TIME_TRANSITION);
    },
    openDropDown() {
      this.hideContent = false;
      this.closeOptions = false;
      this.scrollToEl(this.$refs.multiselect);
    },
    getPrefix(prefix) {
      return prefix ? `${prefix}.` : '';
    },
  },
};
</script>
<style lang="scss">
.multiselect {
  width: 100%;
  padding: 0!important;

  &__content-wrapper {
    position: absolute;
    z-index: 10;
    background-color: white;
    overflow-y: scroll!important;
    width: 100%;
  }

  &__tags {
    min-height: 50px;
    padding: 13px 48px 13px 14px;
  }

  &__input {
    min-height: 50px;
    border: 1px solid #9fb3c3;
    border-radius: 4px;
    transition: none;
    display: none;
  }

  &__content {
    width: 100%;
    padding-left: 0;
  }

  &__element {
    padding: 0;
    list-style-type: none;
    font: 600 18px/26px Open Sans,sans-serif;
    color: #323232;
    word-break: break-word;
    position: relative;
    justify-content: space-between;
    cursor: pointer;
    flex: 0 0 100%;
    font-weight: 400;
    transition: .3s all cubic-bezier(.4,0,.6,1);

    &:hover {
      color: #ED1651;
    }
  }

  &__option {
    display: block;
    width: 100%;
    padding: 12px 30px;
    span {
      hyphens: auto;
    }
  }

  &--active {
    .multiselect {

      &__input {
        display: block;
      }

      &__tags {
        padding: 0;
      }
    }

    & + svg {
      color: #ED1651;
    }
  }
}

.calculator {
  .multiselect-enter-active, .multiselect-leave-active {
    transition: opacity .3s cubic-bezier(0.4, 0, 0.6, 1), max-height .3s cubic-bezier(0.4, 0, 0.6, 1);
  }
  .multiselect-enter, .multiselect-leave-to {
    opacity: 0;
    max-height: 0!important;
  }
  &_hide-content {

    .multiselect__content {
      display: none!important;
    }
  }

  &-field:first-child {
    .multiselect {
      border-left: 1px solid #9fb3c3;

      @media (min-width: 768px) {
        border-radius: 4px 0 0 4px;
      }
    }
  }

  .field-full {
    .multiselect {

      &__tags {
        padding-top: 26px;
        padding-bottom: 10px;

        input {
          padding: 26px 48px 10px 14px;
          line-height: 1;
        }
      }
    }
  }

  .multiselect {
    @media (max-width: 1200px) {
      border-left: 1px solid #9fb3c3;
      border-radius: 4px;
    }
    border-left: 0;
    border-radius: 0;

    .field-input__inner {
      padding: 0;
    }

    &__tags {
      min-height: 58px;
      padding: 18px 40px 18px 15px;

      @media (min-width: 581px) {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__input {
      min-height: 59px;
      border: 0;
      border-bottom: 1px solid #9fb3c3;
      line-height: 1;
    }


    &__placeholder {
      color: #9fb3c3;
    }

    &--active {
      .multiselect {

        &__input {
          display: block;
        }

        &__tags {
          padding: 0;
        }
      }

      & + svg {
        color: #ED1651;
      }
    }
  }
}

.formbar {
  &-field {
    @media (max-width: 1200px) {
       max-width: 50%;
    }
  }
  .multiselect {
    position: relative;
    @media (min-width: 1201px) {
      min-width: 235px;
      max-width: 235px;
    }

    .field-input__inner {
      padding: 0;
    }

    &__tags {
      min-height: 48px;
      padding: 13px 40px 10px 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__input {
      min-height: 48px;
      border: 0;
      border-bottom: 1px solid #9fb3c3;
      border-radius: 4px 4px 0 0;
    }

    &__content {
      min-width: 100%;
      padding-left: 0;
    }

    &__placeholder {
      color: #9fb3c3;
    }

    &--active {

      .multiselect {

        &__placeholder {
          display: none;
        }

        &__input {
          display: block;
        }

        &__tags {
          padding: 0;
        }
      }

      & + svg {
        color: #ED1651;
      }
    }
  }
}

.form_vacancies {
  .multiselect {

    &__content-wrapper {
      max-height: 200px!important;
      left: 0;
      border: 1px solid #9FB3C3;
    }

    &__placeholder {
      color: #9FB3C3;
      font-size: 16px;
      line-height: 22px;
    }

    &__input {
      min-height: 47px;
      border: none;
      border-radius: 4px 4px 0 0;
    }

    &__tags {
      min-height: 47px;
    }

    &--active {

      &__input {
        border: none;
        min-height: 47px;
        border-bottom: 1px solid #9fb3c3;
      }
    }
  }
}
.input-city__desc {}
.input-city__city {
  display: block;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #333;
}
.input-city__city {
  margin-bottom: 2px;
}
.input-city__desc {
  margin-bottom: 3px;
}
.input-city__desc {
  display: flex;
  flex-direction: column;
}
.input-city__region  {
  display: inline-block;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #9FB3C3;
}
.multiselect_city.multiselect.field-input__inner {
  @media(max-width: 1050px) and  (min-width: 581px){
    margin-top: 20px;
    border: 1px solid #9fb3c3 !important;
    border-radius: 4px!important;
  }
  .multiselect__content-wrapper {
    padding: 11px 0 17px 0;
  }
  .multiselect__option {
    padding: 3px 14px 1px 14px;
  }
}
</style>
